// extracted by mini-css-extract-plugin
module.exports = {"power-independence-E":"E_power-independence-E___3NF0"};